// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-a92ab385] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget--list[data-v-a92ab385] {
  width: var(--widget-full-width, 100%);
}
.widgets--list.icon-loading[data-v-a92ab385] {
  min-height: var(--default-clickable-area);
}
/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-3b61be27] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
/* stylelint-disable-next-line scss/at-import-partial-extension */
/**
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
* Styles are extracted to extract scss to dist folder, too.
*/
li.task-list-item > ul[data-v-3b61be27],
li.task-list-item > ol[data-v-3b61be27],
li.task-list-item > li[data-v-3b61be27],
li.task-list-item > blockquote[data-v-3b61be27],
li.task-list-item > pre[data-v-3b61be27] {
  margin-inline-start: 15px;
  margin-block-end: 0;
}
.rich-text--wrapper[data-v-3b61be27] {
  word-break: break-word;
  line-height: 1.5;
}
.rich-text--wrapper .rich-text--fallback[data-v-3b61be27], .rich-text--wrapper .rich-text-component[data-v-3b61be27] {
  display: inline;
}
.rich-text--wrapper .rich-text--external-link[data-v-3b61be27] {
  text-decoration: underline;
}
.rich-text--wrapper .rich-text--external-link[data-v-3b61be27]:after {
  content: " ↗";
}
.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-3b61be27] {
  list-style: decimal;
}
.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-3b61be27] {
  list-style: initial;
}
.rich-text--wrapper .rich-text--list-item[data-v-3b61be27] {
  white-space: initial;
  color: var(--color-text-light);
  padding: initial;
  margin-left: 20px;
}
.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-3b61be27] {
  list-style: none;
  white-space: initial;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-3b61be27] {
  min-height: initial;
}
.rich-text--wrapper .rich-text--strong[data-v-3b61be27] {
  white-space: initial;
  font-weight: bold;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--italic[data-v-3b61be27] {
  white-space: initial;
  font-style: italic;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--heading[data-v-3b61be27] {
  white-space: initial;
  font-size: initial;
  color: var(--color-text-light);
  margin-bottom: 5px;
  margin-top: 5px;
  font-weight: bold;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-3b61be27] {
  font-size: 20px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-3b61be27] {
  font-size: 19px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-3b61be27] {
  font-size: 18px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-3b61be27] {
  font-size: 17px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-3b61be27] {
  font-size: 16px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-3b61be27] {
  font-size: 15px;
}
.rich-text--wrapper .rich-text--hr[data-v-3b61be27] {
  border-top: 1px solid var(--color-border-dark);
  border-bottom: 0;
}
.rich-text--wrapper .rich-text--pre[data-v-3b61be27] {
  border: 1px solid var(--color-border-dark);
  background-color: var(--color-background-dark);
  padding: 5px;
}
.rich-text--wrapper .rich-text--code[data-v-3b61be27] {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper .rich-text--blockquote[data-v-3b61be27] {
  border-left: 3px solid var(--color-border-dark);
  padding-left: 5px;
}
.rich-text--wrapper .rich-text--table[data-v-3b61be27] {
  border-collapse: collapse;
}
.rich-text--wrapper .rich-text--table thead tr th[data-v-3b61be27] {
  border: 1px solid var(--color-border-dark);
  font-weight: bold;
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr td[data-v-3b61be27] {
  border: 1px solid var(--color-border-dark);
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr[data-v-3b61be27]:nth-child(even) {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper-markdown div > *[data-v-3b61be27]:first-child,
.rich-text--wrapper-markdown blockquote > *[data-v-3b61be27]:first-child {
  margin-top: 0 !important;
}
.rich-text--wrapper-markdown div > *[data-v-3b61be27]:last-child,
.rich-text--wrapper-markdown blockquote > *[data-v-3b61be27]:last-child {
  margin-bottom: 0 !important;
}
.rich-text--wrapper-markdown h1[data-v-3b61be27], .rich-text--wrapper-markdown h2[data-v-3b61be27], .rich-text--wrapper-markdown h3[data-v-3b61be27], .rich-text--wrapper-markdown h4[data-v-3b61be27], .rich-text--wrapper-markdown h5[data-v-3b61be27], .rich-text--wrapper-markdown h6[data-v-3b61be27], .rich-text--wrapper-markdown p[data-v-3b61be27], .rich-text--wrapper-markdown ul[data-v-3b61be27], .rich-text--wrapper-markdown ol[data-v-3b61be27], .rich-text--wrapper-markdown blockquote[data-v-3b61be27], .rich-text--wrapper-markdown pre[data-v-3b61be27] {
  margin-top: 0;
  margin-bottom: 1em;
}
.rich-text--wrapper-markdown h1[data-v-3b61be27], .rich-text--wrapper-markdown h2[data-v-3b61be27], .rich-text--wrapper-markdown h3[data-v-3b61be27], .rich-text--wrapper-markdown h4[data-v-3b61be27], .rich-text--wrapper-markdown h5[data-v-3b61be27], .rich-text--wrapper-markdown h6[data-v-3b61be27] {
  font-weight: bold;
}
.rich-text--wrapper-markdown h1[data-v-3b61be27] {
  font-size: 30px;
}
.rich-text--wrapper-markdown ul[data-v-3b61be27], .rich-text--wrapper-markdown ol[data-v-3b61be27] {
  padding-left: 15px;
}
.rich-text--wrapper-markdown ul[data-v-3b61be27] {
  list-style-type: disc;
}
.rich-text--wrapper-markdown ul.contains-task-list[data-v-3b61be27] {
  list-style-type: none;
  padding: 0;
}
.rich-text--wrapper-markdown table[data-v-3b61be27] {
  border-collapse: collapse;
  border: 2px solid var(--color-border-maxcontrast);
}
.rich-text--wrapper-markdown table th[data-v-3b61be27],
.rich-text--wrapper-markdown table td[data-v-3b61be27] {
  padding: var(--default-grid-baseline);
  border: 1px solid var(--color-border-maxcontrast);
}
.rich-text--wrapper-markdown table th[data-v-3b61be27]:first-child,
.rich-text--wrapper-markdown table td[data-v-3b61be27]:first-child {
  border-left: 0;
}
.rich-text--wrapper-markdown table th[data-v-3b61be27]:last-child,
.rich-text--wrapper-markdown table td[data-v-3b61be27]:last-child {
  border-right: 0;
}
.rich-text--wrapper-markdown table tr:first-child th[data-v-3b61be27] {
  border-top: 0;
}
.rich-text--wrapper-markdown table tr:last-child td[data-v-3b61be27] {
  border-bottom: 0;
}
.rich-text--wrapper-markdown blockquote[data-v-3b61be27] {
  padding-left: 13px;
  border-left: 2px solid var(--color-border-dark);
  color: var(--color-text-lighter);
}
a[data-v-3b61be27]:not(.rich-text--component) {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRichText-BKnmtD0n.css"],"names":[],"mappings":"AAAA,gBAAgB,CAAC;;;EAGf;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;AAC3C;AACA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA,iEAAiE;AACjE;;;EAGE;AACF;;CAEC;AACD;;;;;EAKE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE,8CAA8C;AAChD;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,iDAAiD;AACnD;AACA;;EAEE,qCAAqC;EACrC,iDAAiD;AACnD;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["@charset \"UTF-8\";/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-a92ab385] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget--list[data-v-a92ab385] {\n  width: var(--widget-full-width, 100%);\n}\n.widgets--list.icon-loading[data-v-a92ab385] {\n  min-height: var(--default-clickable-area);\n}\n/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-3b61be27] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n/* stylelint-disable-next-line scss/at-import-partial-extension */\n/**\n * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n* Styles are extracted to extract scss to dist folder, too.\n*/\nli.task-list-item > ul[data-v-3b61be27],\nli.task-list-item > ol[data-v-3b61be27],\nli.task-list-item > li[data-v-3b61be27],\nli.task-list-item > blockquote[data-v-3b61be27],\nli.task-list-item > pre[data-v-3b61be27] {\n  margin-inline-start: 15px;\n  margin-block-end: 0;\n}\n.rich-text--wrapper[data-v-3b61be27] {\n  word-break: break-word;\n  line-height: 1.5;\n}\n.rich-text--wrapper .rich-text--fallback[data-v-3b61be27], .rich-text--wrapper .rich-text-component[data-v-3b61be27] {\n  display: inline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-3b61be27] {\n  text-decoration: underline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-3b61be27]:after {\n  content: \" ↗\";\n}\n.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-3b61be27] {\n  list-style: decimal;\n}\n.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-3b61be27] {\n  list-style: initial;\n}\n.rich-text--wrapper .rich-text--list-item[data-v-3b61be27] {\n  white-space: initial;\n  color: var(--color-text-light);\n  padding: initial;\n  margin-left: 20px;\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-3b61be27] {\n  list-style: none;\n  white-space: initial;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-3b61be27] {\n  min-height: initial;\n}\n.rich-text--wrapper .rich-text--strong[data-v-3b61be27] {\n  white-space: initial;\n  font-weight: bold;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--italic[data-v-3b61be27] {\n  white-space: initial;\n  font-style: italic;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--heading[data-v-3b61be27] {\n  white-space: initial;\n  font-size: initial;\n  color: var(--color-text-light);\n  margin-bottom: 5px;\n  margin-top: 5px;\n  font-weight: bold;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-3b61be27] {\n  font-size: 20px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-3b61be27] {\n  font-size: 19px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-3b61be27] {\n  font-size: 18px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-3b61be27] {\n  font-size: 17px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-3b61be27] {\n  font-size: 16px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-3b61be27] {\n  font-size: 15px;\n}\n.rich-text--wrapper .rich-text--hr[data-v-3b61be27] {\n  border-top: 1px solid var(--color-border-dark);\n  border-bottom: 0;\n}\n.rich-text--wrapper .rich-text--pre[data-v-3b61be27] {\n  border: 1px solid var(--color-border-dark);\n  background-color: var(--color-background-dark);\n  padding: 5px;\n}\n.rich-text--wrapper .rich-text--code[data-v-3b61be27] {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper .rich-text--blockquote[data-v-3b61be27] {\n  border-left: 3px solid var(--color-border-dark);\n  padding-left: 5px;\n}\n.rich-text--wrapper .rich-text--table[data-v-3b61be27] {\n  border-collapse: collapse;\n}\n.rich-text--wrapper .rich-text--table thead tr th[data-v-3b61be27] {\n  border: 1px solid var(--color-border-dark);\n  font-weight: bold;\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr td[data-v-3b61be27] {\n  border: 1px solid var(--color-border-dark);\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr[data-v-3b61be27]:nth-child(even) {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper-markdown div > *[data-v-3b61be27]:first-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-3b61be27]:first-child {\n  margin-top: 0 !important;\n}\n.rich-text--wrapper-markdown div > *[data-v-3b61be27]:last-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-3b61be27]:last-child {\n  margin-bottom: 0 !important;\n}\n.rich-text--wrapper-markdown h1[data-v-3b61be27], .rich-text--wrapper-markdown h2[data-v-3b61be27], .rich-text--wrapper-markdown h3[data-v-3b61be27], .rich-text--wrapper-markdown h4[data-v-3b61be27], .rich-text--wrapper-markdown h5[data-v-3b61be27], .rich-text--wrapper-markdown h6[data-v-3b61be27], .rich-text--wrapper-markdown p[data-v-3b61be27], .rich-text--wrapper-markdown ul[data-v-3b61be27], .rich-text--wrapper-markdown ol[data-v-3b61be27], .rich-text--wrapper-markdown blockquote[data-v-3b61be27], .rich-text--wrapper-markdown pre[data-v-3b61be27] {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n.rich-text--wrapper-markdown h1[data-v-3b61be27], .rich-text--wrapper-markdown h2[data-v-3b61be27], .rich-text--wrapper-markdown h3[data-v-3b61be27], .rich-text--wrapper-markdown h4[data-v-3b61be27], .rich-text--wrapper-markdown h5[data-v-3b61be27], .rich-text--wrapper-markdown h6[data-v-3b61be27] {\n  font-weight: bold;\n}\n.rich-text--wrapper-markdown h1[data-v-3b61be27] {\n  font-size: 30px;\n}\n.rich-text--wrapper-markdown ul[data-v-3b61be27], .rich-text--wrapper-markdown ol[data-v-3b61be27] {\n  padding-left: 15px;\n}\n.rich-text--wrapper-markdown ul[data-v-3b61be27] {\n  list-style-type: disc;\n}\n.rich-text--wrapper-markdown ul.contains-task-list[data-v-3b61be27] {\n  list-style-type: none;\n  padding: 0;\n}\n.rich-text--wrapper-markdown table[data-v-3b61be27] {\n  border-collapse: collapse;\n  border: 2px solid var(--color-border-maxcontrast);\n}\n.rich-text--wrapper-markdown table th[data-v-3b61be27],\n.rich-text--wrapper-markdown table td[data-v-3b61be27] {\n  padding: var(--default-grid-baseline);\n  border: 1px solid var(--color-border-maxcontrast);\n}\n.rich-text--wrapper-markdown table th[data-v-3b61be27]:first-child,\n.rich-text--wrapper-markdown table td[data-v-3b61be27]:first-child {\n  border-left: 0;\n}\n.rich-text--wrapper-markdown table th[data-v-3b61be27]:last-child,\n.rich-text--wrapper-markdown table td[data-v-3b61be27]:last-child {\n  border-right: 0;\n}\n.rich-text--wrapper-markdown table tr:first-child th[data-v-3b61be27] {\n  border-top: 0;\n}\n.rich-text--wrapper-markdown table tr:last-child td[data-v-3b61be27] {\n  border-bottom: 0;\n}\n.rich-text--wrapper-markdown blockquote[data-v-3b61be27] {\n  padding-left: 13px;\n  border-left: 2px solid var(--color-border-dark);\n  color: var(--color-text-lighter);\n}\na[data-v-3b61be27]:not(.rich-text--component) {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
